import "../App.scss";
import aboutIcon from "../assets/images/about.png";
import privacyIcon from "../assets/images/privacyPolicy.png";
import termsIcon from "../assets/images/terms&Conditions.png";
import { Link, useNavigate } from "react-router-dom";
const Settings = () => {
  const navigate = useNavigate();

  return (
    <div className="pageContainer">
      <div className="pageHeader row centerAlign" style={{ gap: "1rem" }}>
        <button
          type="button"
          className="icon-buttons h2"
          aria-label="Go back"
          onClick={() => navigate(-1)}
          style={{ padding: "0.5rem", fontSize: "1.5rem" }}
        >
          &#8592;
        </button>
        <div className="h1">Settings</div>
      </div>
      <div
        className="col"
        style={{
          maxWidth: "20rem",
          color: "var(--midGray)",
          marginLeft: "1.5rem",
        }}
      >
        {/* <div
          className="row centerAlign"
          style={{ borderBottom: "1px solid #E9E9E9" }}
        >
          <div style={{ flex: 1 }}>
            <img src={notificationIcon} alt="notification" />
          </div>
          <div className="b1" style={{ padding: "1.3rem", flex: 7 }}>
            Notification
          </div>
          <div style={{ flex: 1 }}>&gt;</div>
        </div> */}
        <Link
          to="/terms-and-conditions"
          className="row centerAlign"
          style={{ borderBottom: "1px solid #E9E9E9" }}
        >
          <div style={{ flex: 1 }}>
            <img src={termsIcon} alt="terms and conditions" />
          </div>
          <div className="b1" style={{ padding: "1.3rem", flex: 7 }}>
            Terms & Conditions
          </div>
          <div style={{ flex: 1 }}>&gt;</div>
        </Link>

        <Link
          to="/privacy-policy"
          className="row centerAlign"
          style={{ borderBottom: "1px solid #E9E9E9" }}
        >
          <div style={{ flex: 1 }}>
            <img src={privacyIcon} alt="privacy policy" />
          </div>
          <div className="b1" style={{ padding: "1.3rem", flex: 7 }}>
            Privacy Policy
          </div>
          <div style={{ flex: 1 }}>&gt;</div>
        </Link>

        <Link
          to="/about-us"
          className="row centerAlign"
          style={{ borderBottom: "1px solid #E9E9E9" }}
        >
          <div style={{ flex: 1 }}>
            <img src={aboutIcon} alt="about us" />
          </div>
          <div className="b1" style={{ padding: "1.3rem", flex: 7 }}>
            About
          </div>
          <div style={{ flex: 1 }}>&gt;</div>
        </Link>
      </div>
    </div>
  );
};

export default Settings;
